import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assigned',
  templateUrl: './assigned.component.html',
  styleUrls: ['./assigned.component.scss'],
})
export class AssignedComponent implements OnInit {
  showDetails:boolean = false;statusCourse:any='';userLoginData:any=[];assignAllCourses:any=[];assignAllCoursess:any=[];assignLetestCourses:any=[];
  indexTab:any=1;assignLetestCoursesLength:any='';assignLetestCoursesPro:any=[];lastViewStatus:any=0;
  user_id:any='';closeResult: any = '';validationMsg:any='';
  course_id:any='';assessment_id:any=''; request_status:number=1;
  constructor(private modalService: NgbModal,private router: Router,private authUser: UsersService,private spinner: NgxSpinnerService) {
    if (localStorage.getItem('userLoginData') =='' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
  }
  showDetailsEvent() { this.showDetails = !this.showDetails; }

  open(content: any, data:any,type:any) {
    this.user_id = data.user_id
    this.course_id=data.course_id
    if(type==1){
      this.assessment_id= data.assessment_id;
    }else{
      this.assessment_id= data.module_assessment_id;
    }
    this.contactAdministrator(this.user_id,this.course_id,this.assessment_id, this.request_status)
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  open1(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    /***login user data ***/
    if(this.userLoginData !='' || this.userLoginData != null){
      this.assignLastViewCours();
      this.assignCourseDetail(this.statusCourse,this.userLoginData.user_id);
    }
  }
  //3 compt and 2 pending and 1 start blank all
  assignCourseDetail(status:any,user_id:any){
    this.spinner.show();
    this.assignAllCourses=[];
    this.authUser.assignCourses(status,user_id).subscribe(
      data=>{
          this.spinner.hide();
          this.assignAllCoursess = data.data;
          let j=0;
          for(let i = 0; i < this.assignAllCoursess.length;i++){
            if(this.assignAllCoursess[i].course_is_active == 1 && this.cousreEndDate(this.assignAllCoursess[i].course_end_date) < 0){
              this.assignAllCourses[j]=this.assignAllCoursess[i];
              j++;
            }
          }
      },error=>{
        this.spinner.hide();
      }
    )
  }
  /*****second convert into hr min and sec */
  secondsToHms(d:any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h+ ' hr ' +m+ ' min';
}
  /****get data of last view submodule */
  assignLastViewCours(){
    this.spinner.show();
    this.authUser.assignLastViewCourse(this.userLoginData.user_id).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
          this.assignLetestCoursesLength = data.data;
          this.lastViewStatus=1;
          this.assignLetestCourses = data.data[0];
          if(data.data.length !=0){
            this.assignLetestCoursesPro = data.data[0].user_course_progress;
          }
          this.spinner.hide();
        }

      },error=>{
        this.spinner.hide();
      }
    )
  }
  changeTab(Tab:any){
    if(Tab =='All'){
    this.indexTab = 1;
    this.statusCourse = '';
    this.assignCourseDetail(this.statusCourse,this.userLoginData.user_id);
    }else if(Tab =='Started'){
      this.indexTab = 2;
      this.statusCourse = 2;
    this.assignCourseDetail(this.statusCourse,this.userLoginData.user_id);
    }else if(Tab =='Not Started'){
      this.indexTab = 3;
      this.statusCourse = 1;
    this.assignCourseDetail(this.statusCourse,this.userLoginData.user_id);
    }
  }
  goViewer(modId:any,subModlId:any,courseId:any){
    this.authUser.subModuleStartView(this.userLoginData.user_id,courseId,modId,subModlId).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
         // debugger
          this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId} });
        }

      },error=>{
      }
    )
  }
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any){
    this.spinner.show();
    this.authUser.contactAdministrator(user_id,course_id,assessment_id, request_status).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
        this.spinner.hide();
        }

      },error=>{
        this.spinner.hide();
      }
    )
  }
  cousreEndDate(endDate:any){
    var date2 = new Date();
    var date1 = new Date(endDate);
    var Time = date2.getTime() - date1.getTime();
    var Days = Time / (1000 * 3600 * 24);
    return Days;
  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/');

  }
}
